import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";

import { Button } from "@hydra/atom/components";
import { BoxedContent, Header, NoDataFound } from "@/components/common";
import { FinanceMasterTable } from "@/components/finance";
import {
  getApprovalMapTableColumns,
  getApprovalMapTableData,
} from "@/components/workflow/approvalMapTableData";
import { getApprovalMaps, deleteApprovalMap } from "@/api/workflow/approvalMapApi";
import { skeletonLoadingRows } from "@/utils/helpers";
import showToast from "@/utils/toast/helpers";

function ApprovalMap() {
  const navigate = useNavigate();

  const { data, isLoading } = useQuery(["approval-map"], () => getApprovalMaps());

  const queryClient = useQueryClient();
  const deleteMutation = useMutation(
    deleteApprovalMap,
    {
      onError: () => {
        showToast("Could not delete. Try again!", "error");
      },
      onSuccess: () => {
        showToast("Deleted successfully", "success");

        queryClient.invalidateQueries({
          queryKey: ["approval-map"]
        });
      },
    }
  );

  const renderTable = () => {
    if (!isLoading && data && !data?.data) {
      return (
        <NoDataFound
          title="No approval map has been added"
          buttonText="Add approval map"
          onClick={() => navigate("/admin/approval-map/new")}
        />
      );
    }
    return (
      <FinanceMasterTable
        objectName="ApprovalMap"
        isLoading={isLoading}
        tableColumns={getApprovalMapTableColumns(data?.data || [])}
        data={getApprovalMapTableData(data?.data || skeletonLoadingRows(5))}
        handleDelete={(id) => deleteMutation.mutate(id)}
        module="admin"
      />
    );
  };

  return (
    <BoxedContent>
      <Header
        showBreadcrumb
        leftContent={<h1>Approval Maps</h1>}
        rightContent={(
          <Button small onClick={() => navigate("/admin/approval-map/new")}>
            Add approval map
          </Button>
        )}
      />

      {renderTable()}
    </BoxedContent>
  );
}

export default ApprovalMap;
